import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-219dbc48"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "information-safety"
};
const _hoisted_2 = {
  class: "top-content"
};
import { useRouter } from 'vue-router';
import { ref } from 'vue';
// const route = useRoute()
export default /*#__PURE__*/_defineComponent({
  __name: 'InformationSafety',
  setup(__props) {
    const router = useRouter();
    const agreementHtml = ref('');
    const agreementUrl = ref('');
    const agreementViewShow = ref(false);
    const clickPrivacy = () => {
      router.push({
        path: '/privacyAgreement'
      });
      // const request = {
      //     agreeCode: 'privacy',
      // }
      // const { code, data, message } = await agreement(request)
      // if (code === 9000) {
      //     agreementHtml.value = data.authAgreeContent
      //     agreementUrl.value = ''
      //     agreementViewShow.value = true
      // }
      // console.log(data.authAgreeContent)
    };

    const clickRegister = async () => {
      router.push({
        path: '/registerAgreement'
      });
      // const request = {
      //     agreeCode: 'register',
      // }
      // const { code, data, message } = await agreement(request)
      // if (code === 9000) {
      //     agreementHtml.value = data.authAgreeContent
      //     agreementUrl.value = ''
      //     agreementViewShow.value = true
      // }
    };

    const clickInformation = () => {
      router.push({
        path: '/safety'
      });
      // agreementHtml.value = ''
      // agreementUrl.value = process.env.VUE_APP_INFORMATION_SAFETY
      // agreementViewShow.value = true
    };

    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell, {
        title: "阳光保险在线网络平台平台隐私政策",
        "is-link": "",
        onClick: clickPrivacy
      }), _createVNode(_component_van_cell, {
        title: "阳光在线会员注册开通协议",
        "is-link": "",
        onClick: clickRegister
      }), _createVNode(_component_van_cell, {
        title: "信息安全保障措施说明",
        "is-link": "",
        onClick: clickInformation
      })])]);
    };
  }
});